import { useSetAtom } from "jotai";
import { Text, Link } from "@zapier/design-system";
import { emitUserInteractionEventSetter } from "@zapier/canvas-state";
import { ALL_GUIDES_URL, GUIDES } from "@zapier/canvas-constants";
import { GuideBlock } from "../GuideBlock";
import styles from "./Guides.module.css";

const LINK_TEXT = "View all guides";

export function Guides() {
  const emitUserInteractionEvent = useSetAtom(emitUserInteractionEventSetter);

  const handleClick = async () => {
    await emitUserInteractionEvent({
      eventAction: "click",
      interactionGoal: "Viewed all guides",
      rawText: LINK_TEXT,
    });
  };

  return (
    <section className={styles.root}>
      <div className={styles.header}>
        <Text type="SectionHeader" color="TextDefault">
          Canvas resources
        </Text>
        <Link
          href={ALL_GUIDES_URL}
          target="_blank"
          onClick={handleClick}
          className={styles.link}
        >
          {LINK_TEXT}
        </Link>
      </div>
      <div className={styles.guidesContainer}>
        {GUIDES.map((guide) => (
          <GuideBlock key={guide.title} guide={guide} />
        ))}
      </div>
    </section>
  );
}
